import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useIntl, FormattedMessage } from 'react-intl';

import {
    formatDollars,
    formatPercentage,
    QuestionMarkButton,
    DefaultIntlFormatValues,
    Sizes,
} from '@ratehub/base-ui';

import CardFeeSummaryContainer from './CardFeeSummaryContainer';


function CardFeeSummaryBalanceTransfer({ cardInfo, onClick, ...otherProps }) {
    const intl = useIntl();

    return (
        <CardFeeSummaryContainer
            {...otherProps}
        >
            <CardFeeSummaryContainer.Description className="row1">
                <FormattedMessage
                    id="ccrt.card.balance-transfer-offer"
                    defaultMessage="Balance transfer offer{newline}<small>First {balanceTransferPromoMonths} months</small>"
                    values={{
                        balanceTransferPromoMonths: cardInfo.balanceTransferPromoMonths,
                        ...DefaultIntlFormatValues,
                    }}
                />
            </CardFeeSummaryContainer.Description>
            <CardFeeSummaryContainer.Value className="row1">
                <output>
                    {formatPercentage(cardInfo.balanceTransferPromoInterest, intl)}
                </output>
            </CardFeeSummaryContainer.Value>

            <CardFeeSummaryContainer.Description className="row2">
                <FormattedMessage
                    id="ccrt.card.balance-transfer-promo-ends"
                    defaultMessage="<small>When promo ends</small>"
                    values={DefaultIntlFormatValues}
                />
            </CardFeeSummaryContainer.Description>
            <CardFeeSummaryContainer.Value className="row2">
                <output>
                    {formatPercentage(cardInfo.balanceTransferInterest, intl)}
                </output>
            </CardFeeSummaryContainer.Value>

            <CardFeeSummaryContainer.Separator className="row3" />

            <CardFeeSummaryContainer.Description className="row4">
                <FormattedMessage
                    id="ccrt.card.balance-transfer-fee"
                    defaultMessage="Balance transfer fee{newline}<small>{balanceTransferFeeRate, number, percent} of transferred balance</small>"
                    values={{
                        balanceTransferFeeRate: cardInfo.balanceTransferFeeRate / 100,
                        ...DefaultIntlFormatValues,
                    }}
                />
            </CardFeeSummaryContainer.Description>
            <CardFeeSummaryContainer.Value className="row4">
                <output>
                    {formatDollars(cardInfo.balanceTransferFee, intl)}
                </output>
                <If condition={onClick}>
                    <MyQuestionMarkButton
                        iconSize={Sizes.ICONS['XS']}
                        onClick={onClick}
                    />
                </If>
            </CardFeeSummaryContainer.Value>

            <CardFeeSummaryContainer.Separator className="row5" />
        </CardFeeSummaryContainer>
    );
}

CardFeeSummaryBalanceTransfer.propTypes = {
    cardInfo: PropTypes.shape({
        balanceTransferInterest: PropTypes.number,
        balanceTransferFee: PropTypes.number.isRequired,
        balanceTransferPromoMonths: PropTypes.number.isRequired,
        balanceTransferFeeRate: PropTypes.number.isRequired,
        balanceTransferPromoInterest: PropTypes.number.isRequired,
    }).isRequired,

    onClick: PropTypes.func,
};

CardFeeSummaryBalanceTransfer.defaultProps = {
    onClick: undefined,
};


const MyQuestionMarkButton = styled(QuestionMarkButton)`
    margin: 0 ${Sizes.SPACING.ONE};
`;

export default observer(CardFeeSummaryBalanceTransfer);
